import { FC } from 'react'
import { Box, Carousel, type CarouselOptions, CarouselSlide, AutoScroll } from '@hermes/web-components'
import PeerEndorsementsCard from '../PeerEndorsementsCard'
import { BodyLarge, Section } from '../styles'
import { TransformHomePageEndorsements } from '../../../types/homePage'
import useTranslateMessage from '../../../hooks/useTranslateMessage'

const CAROUSEL_OPTIONS = {
  type: 'loop',
  lazyLoad: 'sequential',
  perMove: 1,
  gap: '24px',
  drag: 'free',
  autoWidth: true,
  autoScroll: { speed: 0.5, pauseOnHover: true, pauseOnFocus: false },
  pagination: false,
  arrows: false
} as CarouselOptions

type Props = {
  endorsements: TransformHomePageEndorsements[]
}

const PeerEndorsementsSection: FC<Props> = ({ endorsements }) => {
  const translate = useTranslateMessage()
  return (
    <Section sx={{ maxWidth: '100%', padding: 0, marginBottom: { xs: '52px', lg: '24px' } }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        <BodyLarge variant="h3">{translate('homepage.search.peerrecomendation.title')}</BodyLarge>
        <Carousel lazyLoad options={CAROUSEL_OPTIONS} extensions={{AutoScroll}}>
          {endorsements?.map((item) => (
            <CarouselSlide key={item.id}>
              <PeerEndorsementsCard {...item} />
            </CarouselSlide>
          ))}
        </Carousel>
      </Box>
    </Section>
  )
}

export default PeerEndorsementsSection
